import { useCallback, useState } from 'react';

export const useDebounce = (timeout: number) => {
    const [ buffer, setBuffer ] = useState<NodeJS.Timeout>();
    
    return useCallback((cb: any) => {
        clearTimeout(buffer);
        setBuffer(setTimeout(cb, timeout));
    }, [ buffer, timeout ]);
};
